import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appOnlyNumbersAllowed]',

})
export class OnlyNumbersAllowedDirective {

  constructor() { }
  @HostListener('input', ['$event'])
  onInputChange(event: InputEvent) {
    const input = event.target as HTMLInputElement;
    const originalValue = input.value;

    let cleaned = originalValue.replace(/[^0-9.]/g, '');
  
    const parts = cleaned.split('.');
    if (parts.length > 2) {
      cleaned = parts[0] + '.' + parts[1];
    }
  
    if (parts.length === 2) {
      parts[0] = parts[0].substring(0, 3); 
      parts[1] = parts[1].substring(0, 2);
      cleaned = parts[0] + '.' + parts[1];
    } else {
      cleaned = parts[0].substring(0, 4);
    }
  
    if (cleaned !== originalValue) {
      input.value = cleaned;
      input.dispatchEvent(new Event('input'));
    }
  }
}  